import React from 'react';

import PropTypes from 'prop-types';

import { Dropdown } from '@src/components/ui/Dropdown';
import { GuideResourceTypes } from '@src/utils/guideResourceTypes';


const GuideResourceTypesDropdown = ({ onChange, selectedResourceType }) => {
    const handleChange = React.useCallback((value) => {
        if (value === Dropdown.ALL_OPTION) {
            value = null;
        }

        if (onChange) {
            onChange(value);
        }
    }, [onChange]);

    return (
        <Dropdown
            defaultSelection="Resource"
            title="Resource"
            list={GuideResourceTypes}
            selectedOption={selectedResourceType}
            onChange={handleChange}
        />
    );
};

GuideResourceTypesDropdown.propTypes = {
    selectedResourceType: PropTypes.string,
    onChange: PropTypes.func,
};

export default GuideResourceTypesDropdown;
